import { Component, OnInit } from "@angular/core";
import { GlobalsService } from "../../api/globals.service";
import { NavController } from "@ionic/angular";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public ismobile: boolean;
  navega: string;
  constructor(
    public globalsService: GlobalsService,
    public navCtrl: NavController,
    private authService: AuthService
  ) {
    this.ismobile = globalsService.isMobile;
    this.authService.userData$.subscribe((res: any) => {
      if (res.id) {
        this.navega = "/";
      } else {
        this.navega = "/auth/";
      }
      // Handle user data here
    });
  }

  ngOnInit() {}

  getFooter(ruta) {
    this.navega = this.navega + ruta;
    console.log("🚀 ~ FooterComponent ~ getFooter ~ this.navega:", this.navega);
    this.navCtrl.navigateRoot(this.navega);
    //this.router.navigateByUrl('/libreria');
  }
}
